exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1LGPhYAQJgMwHZjoMTLUCV{min-width:276px}._2qd8K10f-G5_xlMTXky4wM{width:100%}html[dir] ._2qd8K10f-G5_xlMTXky4wM{margin-top:15px}", ""]);

// exports
exports.locals = {
	"menuFeedback": "_1LGPhYAQJgMwHZjoMTLUCV",
	"sendButton": "_2qd8K10f-G5_xlMTXky4wM"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":{"orderedValues":false}}!./node_modules/postcss-loader/lib?{"plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./obj/controls/header/owa-header-pane/lib/components/FeedbackPane.scss
// module id = 6227
// module chunks = 38